export class CustCard_3 {
    customerId: number;
    firstName?: string;
    lastName?: string;
    sex?: number;
    pelephone?: string;
    phone?: string;
    birthDay?: string | Date;
    address?: string;
    cityName?: string;
    email?: string;
    sourceName?: string;
    recommenderfl?: string;
    saparName?: string;
    idOfCategery?: string;
    identicalNum?: string;
    wedding_Date?: string | Date;
    kindDrink?: string;
    faceBook?: string;
    isSendSMS?: boolean;
    aditionalPhone?: string;
    instLink?: string;
    isBlockedMarketingMessages?: boolean;
    cityID?: number;
    recommenderCustID?: number;
    saparID?: number;
    sourceID?: number;
    imagePath?: string;
    occupationId?: number;
    occupationName?: string;
}


export class ExecAnswer {
    answer?: boolean;
    custIdMax?: number;
}